import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import { IMenu } from '../fragments.interfaces';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
// import { CreateModalComponent } from 'app/create-modal/create-modal.component';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../../shared/services/auth.service';
import { Broadcaster } from '../../../../shared/components/broadcaster.component';
import { NotificationsService } from '../../../../shared/notifications/notifications.service';
import { CreateModalComponent } from '../create-modal/create-modal.component';
import { CompaniesService } from '../../../../admin/companies-page/companies/companies.service';
// import { ICompany } from 'app/companies/companies.interface';
// import { CompaniesService } from 'app/companies/companies.service';

declare const $: any;
let self: any;

@Component({
  selector: 'app-manax-side-navbar',
  templateUrl: './side-navbar.component.html',
  styleUrls: ['./side-navbar.component.css']
})
export class SideNavbarComponent implements OnInit {
  @Input('collapsed') collapsed: boolean = false;
  @Output('selected') selected = new EventEmitter<any>();

  menuList!: IMenu[];
  companyName!: string;
  isManax = false;
  isAdmin = false;
  isDev = false;
  profile: any = null;
  companies: any = [];
  activeCompany: any;
  _activeCompany: any;
  querySubscription!: Subscription;
  // currentCompany: ICompany;
  currentCompany: any;
  unreadTaskRequestNotificationsCount: number = 0;
  pendingTaskRequestNotificationsCount: number = 0;

  constructor(
    private _AuthService: AuthService,
    private _CompaniesService: CompaniesService,
    private _broadcaster: Broadcaster,
    private _notificationsService: NotificationsService,
    private _viewContainerRef: ViewContainerRef,
    private _dialog: MatDialog,
    private _route: ActivatedRoute,
    private ref: ChangeDetectorRef
  ) {
    self = this;
  }

  ngOnInit() {
    this._notificationsService.pendingTaskRequestCount$.subscribe(count => {
      this.pendingTaskRequestNotificationsCount = count;
    });

    this._notificationsService.unreadTaskRequestCount$.subscribe(count => {
      this.unreadTaskRequestNotificationsCount = count;
    });

    this.isManax = this._AuthService.isManax();
    this.isAdmin = this._AuthService.isRole('admin');
    this.isDev = this._AuthService.isRole('dev');
    this.getCompany()
    const i = this._AuthService.companyIndex();

    this.profile = this._AuthService.profile();
    this.companies = this.profile.company;
    this.companyName = this.companies[this._AuthService.companyIndex()].name;
    this.activeCompany = this._AuthService.companyIndex();
    this._activeCompany = this._AuthService.companyIndex();

    const ROUTES: IMenu[] = [];

    // home
    ROUTES.push({ routerLink: `/admin/${i}/account`, text: 'Mi Cuenta', icon: 'account_circle', children: null, class: 'd-block d-md-none' });
    ROUTES.push({ routerLink: `/admin/${i}/home`, text: 'Inicio', icon: 'dashboard', children: null });

    // schedule
    ROUTES.push({ routerLink: `/admin/${i}/calendar`, text: 'Agenda', icon: 'event_note', children: null });
    /*
    let agendaMenu: IMenu = { text: 'Agenda', icon: 'event_note', children: [] };
    if (this.isAdmin || this.isManax) {
      agendaMenu.children && agendaMenu.children.push({ routerLink: `/admin/${i}/calendar`, text: 'Vista General', icon: 'event_note' });
      agendaMenu.children && agendaMenu.children.push({ routerLink: `/admin/${i}/calendar-by-worker`, text: 'Vista por Trabajador', icon: 'event_note' });
      //agendaMenu.children.push({ routerLink: `/admin/${i}/calendar-by-client`, text: 'Vista por Cliente', icon: 'event_note' });
    }
    ROUTES.push(agendaMenu);
    */
    ROUTES.push({ routerLink: `/admin/${i}/projects`, text: 'Proyectos', icon: 'folder', children: null, separator: true });

    // bussines logic
    ROUTES.push({ routerLink: `/admin/${i}/task-requests`, text: 'Solicitudes', icon: 'move_to_inbox', children: null });
    ROUTES.push({ routerLink: `/admin/${i}/quotes`, text: 'Presupuestos', icon: 'request_quote', children: null });
    ROUTES.push({ routerLink: `/admin/${i}/tasks-status`, text: 'Trabajos', icon: 'business_center', children: null, hidden: true });
    ROUTES.push({ routerLink: `/admin/${i}/tasks-list`, text: 'Trabajos', icon: 'business_center', children: null });
    ROUTES.push({ routerLink: `/admin/${i}/delivery-notes`, text: 'Albaranes', icon: 'assignment', children: null });
    ROUTES.push({ routerLink: `/admin/${i}/billing-documents`, text: 'Facturas', icon: 'paid', children: null, separator: true });
    //ROUTES.push({ routerLink: `/admin/${i}/agents`, text: 'Representantes', icon: 'badge', children: null });

    ROUTES.push({ routerLink: `/admin/${i}/clients`, text: 'Clientes', icon: 'face', children: null });
    if (this.isAdmin || this.isManax) {
      ROUTES.push({ routerLink: `/admin/${i}/workers`, text: 'Trabajadores', icon: 'groups', children: null });
      ROUTES.push({ routerLink: `/admin/${i}/time-track`, text: 'Fichajes', icon: 'access_time', children: null });
      ROUTES.push({ routerLink: `/admin/${i}/tasks-comments`, text: 'Notas y adjuntos', icon: 'forum', children: null });
      ROUTES.push({ routerLink: `/admin/${i}/expenses-report`, text: 'Gastos y Compras', icon: 'sell', children: null });
    }

    // reports
    let reporteMenu: IMenu = { text: 'Reportes', icon: 'summarize', children: [], separator: true };
    if (this.isAdmin || this.isManax) {
      reporteMenu.children && reporteMenu.children.push({ routerLink: `/admin/${i}/report-time-track-client`, text: 'Horas por Cliente', icon: 'summarize' });
      reporteMenu.children && reporteMenu.children.push({ routerLink: `/admin/${i}/report-time-track-worker`, text: 'Horas por Trabajador', icon: 'summarize' });
    }
    ROUTES.push(reporteMenu);

    // configuration
    if (this.isAdmin || this.isManax) {
      let configMenu: IMenu = { text: 'Configuración', icon: 'settings', children: [] };
      // configMenu.children.push({ routerLink: `/admin/${i}/schedules`, text: 'Agenda / Recurrencias', icon: 'today' });
      configMenu.children && configMenu.children.push({ routerLink: `/admin/${i}/products`, text: 'Tarifas', icon: 'attach_money' });
      configMenu.children && configMenu.children.push({ routerLink: `/admin/${i}/expenses`, text: 'Costos', icon: 'money_off' });
      configMenu.children && configMenu.children.push({ routerLink: `/admin/${i}/categories`, text: 'Categorías', icon: 'category' });
      configMenu.children && configMenu.children.push({ routerLink: `/admin/${i}/vendors`, text: 'Proveedores', icon: 'storefront' });
      configMenu.children && configMenu.children.push({ routerLink: `/admin/${i}/users`, text: 'Usuarios', icon: 'person' });
      if (this.isManax) {
        configMenu.children && configMenu.children.push({ routerLink: `/admin/${i}/settings-company`, text: 'Opciones Generales', icon: 'tune' });
        configMenu.children && configMenu.children.push({ routerLink: `/admin/${i}/companies`, text: 'Empresas', icon: 'store' });
        configMenu.children && configMenu.children.push({ routerLink: `/admin/${i}/roles`, text: 'Roles', icon: 'people' });
        configMenu.children && configMenu.children.push({ routerLink: `/admin/${i}/countries`, text: 'Paises', icon: 'public' });
        configMenu.children && configMenu.children.push({ routerLink: `/admin/${i}/currencies`, text: 'Monedas', icon: 'paid' });
        configMenu.children && configMenu.children.push({ routerLink: `/admin/${i}/features`, text: 'Features', icon: 'star' });
        configMenu.children && configMenu.children.push({ routerLink: `/admin/${i}/logger`, text: 'Logger', icon: 'monitoring' });
      }
      ROUTES.push(configMenu);
    }

    ROUTES.push({ routerLink: `/login`, text: 'Salir', icon: 'logout', children: null, class: 'd-block d-md-none' });
    this.menuList = ROUTES;

    /* refactor: me duele la vista */
    this.querySubscription = this._route.url.subscribe(url => {
      const tasksBtn = this.menuList.find(el => el.routerLink == `/admin/${i}/tasks`);
      const tasksStatusBtn = this.menuList.find(el => el.routerLink == `/admin/${i}/tasks-status`);
      try { if (tasksBtn) tasksBtn.hidden = false; } catch (e) { }
      try { if (tasksStatusBtn) tasksStatusBtn.hidden = false; } catch (e) { }


      if (window.location.href.indexOf(`/admin/${i}/tasks-status`) > -1) {
        if (tasksBtn) tasksBtn.hidden = true;
      } else if (window.location.href.indexOf(`/admin/${i}/tasks`) > -1) {
        if (tasksStatusBtn) tasksStatusBtn.hidden = true;
      } else {
        if (tasksStatusBtn) tasksStatusBtn.hidden = true;
      }
    });
    /* refactor */
  }

  scheduleDemo() {
    window.open('https://meetings-eu1.hubspot.com/bruno-calcagno/demo', '_blank');
  }

  getCompany() {
    this._CompaniesService.getCompany(this._AuthService.companyId()).subscribe((company) => {
      this.currentCompany = company;
    });
  }

  ngOnDestroy() {
    this.querySubscription.unsubscribe();
  }

  openedMenu!: IMenu | null;
  setOpened(menu: IMenu) {
    menu.opened = true;
    if (this.openedMenu) this.openedMenu.opened = false;
    this.openedMenu = menu;
  }

  selectedMenu!: IMenu;
  onSelect(item?: IMenu) {
    this.menuCloseAll();
    this.selectedMenu = item as any;
    this.selected.emit(true);
  }

  menuCloseAll() {
    this.menuList.forEach(item => item.opened = false);
    this.openedMenu = null;
  }

  onCompanyChange() {
    setTimeout(() => {
      window.location.href = window.location.href.replace('/admin/' + this._activeCompany, '/admin/' + this.activeCompany);
      this._activeCompany = this.activeCompany;
      window.location.reload();
    }, 500);
  }

  onCompanyOpenNewWindow(i: number) {
    setTimeout(() => {
      window.open(window.location.href.replace('/admin/' + this._activeCompany, '/admin/' + i), '_blank');
    }, 500);
  }

  openMenu() {
    this.collapsed = false;
  }

  _onMouseMoveAux: number = 0;
  onMouseMove(close = false) {
    this.ref.detectChanges();
    let time = new Date().getTime();
    this._onMouseMoveAux = time;
    if (close) this.menuCloseAll();
    setTimeout(() => {
      if (time == this._onMouseMoveAux && this.collapsed) this._broadcaster.broadcast('OnResizeMenu');
    }, 100)
  }

  onCreateNew() {
    this.menuCloseAll();
    this.selected.emit(true);
    let config = new MatDialogConfig();
    config.width = '450px';
    config.maxWidth = '90vw';
    config.viewContainerRef = this._viewContainerRef;
    self.dialogRef = this._dialog.open(CreateModalComponent, config);

    self.dialogRef.afterClosed().subscribe((result: any) => {
      self.dialogRef = null;
    });
  }
}
